import styled from "@xstyled/styled-components";
import { tokens } from "../utils/theme";

export const LayoutContainer = styled.div`
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background: ${props => tokens(props.theme.palette.mode).background.app};
  padding: 12px;
  overflow: hidden;
  display: flex;
  
  @media (max-width: 900px) {
    height: auto;
    min-height: 100vh;
    padding: 0;
  }
`;

export const AppInner = styled.div`
  flex: 1;
  display: flex;
  background: ${props => tokens(props.theme.palette.mode).background.appInner};
  border-radius: 24px;
  border: 1px solid rgba(130, 170, 255, 0.25);
  backdrop-filter: blur(22px);
  overflow: hidden;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const MainContent = styled.main`
  flex: 1;
  padding: 18px 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  width: 100%;
  width: 100%;
  overflow: hidden;
  color: ${props => props.theme.palette.text.primary};
`;
